module.exports = __webpack_public_path__ + "static/media/standard.c878c385.svg";